import { getVideo } from './videos';

/**
 * Sources d'une vidéo, du plus efficace au plus compatible.
 * - `av1` / `vp9` : servis depuis le volume (`/media/...`), générés une fois par
 *   le serveur. Peuvent être temporairement absents (404) : le navigateur passe
 *   alors à la source suivante — jusqu'au H.264, toujours présent.
 * - `h264` : source de repli universelle, embarquée dans le build (git).
 */
export interface VideoSources {
  h264: string;
  av1?: string;
  vp9?: string;
}

/**
 * Construit les URLs AV1/VP9 à partir de l'URL H.264 hashée par Vite
 * (`/assets/popshake-<hash>.mp4` → `/media/popshake-<hash>.av1.mp4`, `.vp9.webm`).
 * L'empreinte de contenu de Vite fait office de clé : une vidéo modifiée change
 * de nom, donc de variantes — aucune obsolescence côté volume.
 */
export function getVideoSources(assetPath: string | undefined): VideoSources | undefined {
  const h264 = getVideo(assetPath);
  if (!h264) return undefined;

  const fileName = h264.split('/').pop() ?? '';
  const base = fileName.replace(/\.mp4(?:$|\?.*$)/i, '');
  // Si on n'a pas su isoler un nom de base propre (ex. URL de dev inhabituelle),
  // on se contente du H.264 : le site fonctionne quand même.
  if (!base || base === fileName) return { h264 };

  return {
    h264,
    av1: `/media/${base}.av1.mp4`,
    vp9: `/media/${base}.vp9.webm`,
  };
}
